import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { TableCell, TableRow, Collapse } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { formatterCLP, formatterKm } from '../../../../../helpers/formatters';

import stylesTable from '../../style';
import getUniqueKey from '../../../../../helpers/customKey';

const ExpensesTable = ({ billDays, handleModalContent }) => {
  const [open, setOpen] = useState(true);

  const totalInfo = billDays.reduce(
    (acc, billDay) => {
      const {
        km,
        installment,
        expenses: { fines, penaltys, other },
        tag,
        references,
      } = billDay;

      const totalTag = tag.reduce((accTag, currentTag) => {
        return accTag + currentTag.amount;
      }, 0);
      const refKmCost = references.filter(
        (ref) => ref.field === 'rent' && !ref.base && ref.type === 'expenses',
      );
      const refBaseCost = references.filter(
        (ref) => ref.field === 'rent' && ref.base && ref.type === 'expenses',
      );

      const elemBaseReference = refBaseCost.reduce((accRefBase, ref) => accRefBase + ref.amount, 0);
      const elemReferenceKmCost = {
        amount: refKmCost.reduce((accRefKmCost, ref) => accRefKmCost + ref.amount, 0),
        kms: refKmCost.reduce((accRefKmCost, ref) => accRefKmCost + ref.kms, 0),
      };

      const totalKmCost = elemReferenceKmCost.amount || 0;
      const totalBasePrice = elemBaseReference || 0;

      return {
        totalBasePrice: totalBasePrice + acc.totalBasePrice,
        km: km + acc.km,
        totalKmCost: totalKmCost + acc.totalKmCost,
        installment: installment + acc.installment,
        totalTag: totalTag + acc.totalTag,
        totalFines: fines + acc.totalFines,
        totalPenaltys: penaltys + acc.totalPenaltys,
        totalOther: other + acc.totalOther,
      };
    },
    {
      totalBasePrice: 0,
      km: 0,
      totalKmCost: 0,
      installment: 0,
      totalTag: 0,
      totalFines: 0,
      totalPenaltys: 0,
      totalOther: 0,
    },
  );

  return (
    <>
      <TableRow onClick={() => setOpen(!open)}>
        <TableCell
          sx={{
            position: 'relative',
            ...stylesTable.headerColumn,
            ...stylesTable.stickyHeader,
          }}
        >
          Costos
          <ChevronRightRoundedIcon
            sx={{
              ...stylesTable.iconArrow,
              right: '5px',
              transform: open ? 'translateY(-50%) rotate(90deg)' : 'translateY(-50%) rotate(0deg)',
              transition: 'transform 0.3s ease',
            }}
          />
        </TableCell>
        {billDays.map((_, index) => {
          const key = `Cobros-${index}`;
          return <TableCell key={key} />;
        })}
        <TableCell sx={{ ...stylesTable.totalCell }} />
      </TableRow>

      <TableRow>
        <TableCell
          sx={{
            ...stylesTable.stickyHeader,
            ...stylesTable.headerText,
          }}
        >
          <Collapse sx={stylesTable.collapseTitle} in={open} timeout="auto" unmountOnExit>
            Valor base
          </Collapse>
        </TableCell>
        {billDays.map((elem) => {
          const key = `shiftValue-${getUniqueKey()}`;
          const { references } = elem;

          const elemento = references.filter(
            (ref) => ref.field === 'rent' && ref.base && ref.type === 'expenses',
          );
          const elemReference = {
            amount: elemento.reduce((acc, ref) => acc + ref.amount, 0),
            base: true,
            type: 'expenses',
            field: 'rent',
            kms: elemento.reduce((acc, ref) => acc + ref.kms, 0),
          };
          return (
            <TableCell key={key} align="center" sx={{ ...stylesTable.regularText }}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                {elemReference.amount ? formatterCLP.format(elemReference.amount) : '$0'}
              </Collapse>
            </TableCell>
          );
        })}
        <TableCell align="center" sx={{ ...stylesTable.regularText, ...stylesTable.totalCell }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {formatterCLP.format(totalInfo.totalBasePrice)}
          </Collapse>
        </TableCell>
      </TableRow>

      <TableRow sx={{ backgroundColor: '#E3EDF7' }}>
        <TableCell
          sx={{
            ...stylesTable.stickyHeader,
            ...stylesTable.headerText,
          }}
        >
          <Collapse sx={stylesTable.collapseTitle} in={open} timeout="auto" unmountOnExit>
            Kilometraje diario
          </Collapse>
        </TableCell>

        {billDays.map((elem, index) => {
          const key = `kmDiary-${index}`;
          const { km } = elem;
          return (
            <TableCell key={key} align="center" sx={{ ...stylesTable.regularText }}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                {formatterKm.format(km)}km
              </Collapse>
            </TableCell>
          );
        })}
        <TableCell align="center" sx={{ ...stylesTable.regularText, ...stylesTable.totalCell }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {formatterKm.format(totalInfo.km)}km
          </Collapse>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          sx={{
            position: 'relative',
            ...stylesTable.stickyHeader,
            ...stylesTable.headerText,
          }}
        >
          <Collapse sx={stylesTable.collapseTitle} in={open} timeout="auto" unmountOnExit>
            Descuento aplicado
          </Collapse>
        </TableCell>

        {billDays.map((elem, index) => {
          const key = `costKm-${index}`;
          const { discount } = elem;

          return (
            <TableCell key={key} align="center" sx={{ ...stylesTable.regularText }}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                {discount}%
              </Collapse>
            </TableCell>
          );
        })}
        <TableCell align="center" sx={{ ...stylesTable.regularText, ...stylesTable.totalCell }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            -
          </Collapse>
        </TableCell>
      </TableRow>

      <TableRow sx={{ backgroundColor: '#E3EDF7' }}>
        <TableCell
          sx={{
            position: 'relative',
            ...stylesTable.stickyHeader,
            ...stylesTable.headerText,
          }}
          onClick={() => handleModalContent('kmCost')}
        >
          <Collapse sx={stylesTable.collapseTitle} in={open} timeout="auto" unmountOnExit>
            Costo km
            <ChevronRightRoundedIcon sx={stylesTable.iconArrow} />
          </Collapse>
        </TableCell>

        {billDays.map((elem) => {
          const key = `costKm-${getUniqueKey()}`;
          const { references } = elem;

          const elemento = references.filter(
            (ref) => ref.field === 'rent' && !ref.base && ref.type === 'expenses',
          );
          const elemReference = {
            amount: elemento.reduce((acc, ref) => acc + ref.amount, 0),
            base: false,
            type: 'expenses',
            field: 'rent',
            kms: elemento.reduce((acc, ref) => acc + ref.kms, 0),
          };
          return (
            <TableCell key={key} align="center" sx={{ ...stylesTable.regularText }}>
              <Collapse in={open} timeout="auto" unmountOnExit>
                {elemReference.amount > 0 ? formatterCLP.format(elemReference.amount) : '$0'}
              </Collapse>
            </TableCell>
          );
        })}
        <TableCell align="center" sx={{ ...stylesTable.regularText, ...stylesTable.totalCell }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {formatterCLP.format(totalInfo.totalKmCost)}
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

ExpensesTable.propTypes = {
  billDays: PropTypes.arrayOf(PropTypes.shape({})),
  handleModalContent: PropTypes.func,
};

ExpensesTable.defaultProps = {
  billDays: [],
  handleModalContent: () => {},
};

export default ExpensesTable;
